<!-- FREEFORM COMPONENT - is not connected to control, we get result by emmiting value outside -->

<mat-form-field class="w-100 text-area-freeform" [class.error-input]="errorMessage">
  @if (helpText) {
    <app-help-text [dataContext]="helpText"></app-help-text>
  }
  <textarea
    rows="{{ rows }}"
    matInput
    [placeholder]="caption | translate"
    [required]="required ? true : null"
    [readonly]="isReadonly ? true : null"
    [value]="value"
    (input)="onTextChange($event)"
    [class.error-input]="errorMessage"
    >
  </textarea>
  @if (errorMessage) {
    <mat-hint class="error-message">{{ errorMessage }}</mat-hint>
  }
</mat-form-field>
